  <cu-validation-messages
    *ngIf="card.visible && !card.valid && (pageSubmitted$ | async)"
    [displayFormat]="'alert'"
    [pageIterationId]="card.pageIterationId"
    [iterationId]="card.iterationId"
    [failedValidations]="card.failedValidations"
    [validationMessages]="card.config.validationMsg"></cu-validation-messages>
